import angular from "angular";

import UserAuthModuleConstants from "./ModuleConstants";
import TbSignInComponentModule from "./TbSignIn";
import TbSignOutDirectiveModule from "./TbSignOut";

export default angular
    .module(UserAuthModuleConstants.module_name, [
        TbSignInComponentModule,
        TbSignOutDirectiveModule
    ])
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/directives/user-auth/index.js
// module id = L+Kn
// module chunks = 1